import { combineReducers } from 'redux';
import toastReducer from '../../components/toast/toast-reducer';
import modalContainerReducer from '../modal-manager/modal-manager-reducer';
import UPFAssignReducer from '../upf-assign/upf-assign-reducer';
import linkUpfModalReducer from '../link-upf-modal/link-upf-modal-reducer';

const CombinedReducers = combineReducers({
  product: state => ({ ...state }),
  toastReducer,
  modalContainerReducer,
  UPFAssignReducer,
  linkUpfModalReducer
});

export default CombinedReducers;
